export class UsersApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Get the current user's profile.
     *
     * @returns User profile with avatar data
     */
    async getProfile() {
        return this.client.get('/api/users/me');
    }
    /**
     * Request email verification.
     *
     * Sends a verification code to the specified email address.
     *
     * @param params - Email address to verify
     * @returns Success on code sent
     */
    async requestEmailVerification(params) {
        return this.client.post('/api/users/me/email', params);
    }
    /**
     * Verify email address with OTP.
     *
     * @param params - Email and verification code
     * @returns Updated user profile on success
     */
    async verifyEmail(params) {
        return this.client.post('/api/users/me/email/verify', params);
    }
    /**
     * Request phone verification.
     *
     * Sends a verification code to the specified phone number.
     *
     * @param params - Phone number to verify
     * @returns Success on code sent
     */
    async requestPhoneVerification(params) {
        return this.client.post('/api/users/me/phone', params);
    }
    /**
     * Verify phone number with OTP.
     *
     * @param params - Phone and verification code
     * @returns Updated user profile on success
     */
    async verifyPhone(params) {
        return this.client.post('/api/users/me/phone/verify', params);
    }
    /**
     * Get the current user's theme and appearance preferences.
     */
    async getPreferences() {
        return this.client.get('/api/users/me/preferences');
    }
    /**
     * Update the current user's theme and appearance preferences.
     */
    async updatePreferences(prefs) {
        return this.client.put('/api/users/me/preferences', prefs);
    }
    async updateDisplayName(displayName) {
        return this.client.patch('/api/users/me/display-name', { displayName });
    }
    /** Current account session maximum and when this device will be forced to sign out. */
    async getSessionLifetime() {
        return this.client.get('/api/users/me/session-lifetime');
    }
    /** Set the account session maximum. Applies immediately. */
    async updateSessionLifetime(maxAgeDays) {
        return this.client.put('/api/users/me/session-lifetime', { maxAgeDays });
    }
}
//# sourceMappingURL=users-api.js.map